import { Component } from '@angular/core';
import { ThemeService, ThemeConfig } from '../../../core/services/theme.service';

@Component({
  selector: 'app-theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.scss'],
  standalone: false
})
export class ThemeSwitcherComponent {
  themes: ThemeConfig[] = [];
  currentTheme: ThemeConfig;

  constructor(private themeService: ThemeService) {
    this.themes = this.themeService.getAvailableThemes();
    this.currentTheme = this.themeService.getCurrentTheme();

    // Subscribe to theme changes
    this.themeService.currentTheme$.subscribe((theme: ThemeConfig) => {
      this.currentTheme = theme;
    });
  }

  onThemeChange(themeId: string): void {
    this.themeService.setTheme(themeId);
  }

  isActive(themeId: string): boolean {
    return this.themeService.isThemeActive(themeId);
  }
}
